import { createSlice } from "@reduxjs/toolkit";
import { EInvoiceStatus } from "../../shared/enums/invoices/EInvoice";

export interface IEnums {
  orderType: string[];
  contractType: string[];
  employeeType: string[];
  genderType: string[];
  maritalType: string[];
  religionType: string[];
  roleType: string[];
  workModeType: string[];
  holidayType: string[];
  country: string[];
  projectType: string[];
  projectStatusType: string[];
  expensesType: string[];
  teamSize: string[];
  clientStatus: string[];
  currencies: string[];
  offerStatus?: string[];
  invoiceStatus: EInvoiceStatus[];
}
const initialState: IEnums = {
  orderType: [],
  contractType: [],
  employeeType: [],
  genderType: [],
  maritalType: [],
  religionType: [],
  roleType: [],
  workModeType: [],
  holidayType: [],
  projectType: [],
  country: [],
  projectStatusType: [],
  expensesType: [],
  teamSize: [],
  clientStatus: [],
  currencies: [],
  invoiceStatus: [],
  offerStatus: [],
};

const enumsSlice = createSlice({
  name: "enums",
  initialState,
  reducers: {
    setEnums: (state, action) => {
      state = action.payload;
      return state;
    },
  },
});

export default enumsSlice;
